import {OptionTypeBase} from 'platform/components';

import {isNil} from 'ramda';

import {GetSpacesResponse} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

export const getSpaceOptions = (spaces: GetSpacesResponse | Nullish): OptionTypeBase<string>[] => {
  if (isNil(spaces)) {
    return [];
  }

  return spaces.map((space) => ({
    label: space.name,
    value: space.spaceId,
  }));
};
